var exports = {
  "a": "Box__N5zHU7",
  "w": "Box_1__a72-Ii",
};

module.exports = exports;
